import type {JobScheduleKind, JobTimeSpan} from './types'
import type {UnassignedJob} from './types'

export function calendarDaySpan(
    span: JobTimeSpan | undefined,
    scheduleKind: JobScheduleKind,
): number {
    if (span?.daySpan != null && span.daySpan > 0) {
        return span.daySpan
    }
    if (scheduleKind === 'two_day') {
        return 2
    }
    return 1
}

export function jobIntersectsHorizon(
    span: JobTimeSpan | undefined,
    scheduleKind: JobScheduleKind,
    dayCount: number,
    viewDayOriginOffset = 0,
): boolean {
    const start = span?.dayOffset ?? 0
    const end = start + calendarDaySpan(span, scheduleKind) - 1
    const viewStart = start - viewDayOriginOffset
    const viewEnd = end - viewDayOriginOffset
    if (start < viewDayOriginOffset) {
        return true
    }
    return viewStart < dayCount && viewEnd >= 0
}

export function unassignedJobIntersectsHorizon(job: UnassignedJob, dayCount: number): boolean {
    return jobIntersectsHorizon(job.span, job.scheduleKind, dayCount)
}
